import styles from "../Style/womenPage.module.css";
import { Button , Box, Heading, Text} from "@chakra-ui/react"
import { Footer } from "../Components/Footer";
import Navbar from "../Routes/Navbar";
import { useState } from "react";
import { AppContext } from "../Context/AppContext";
import { useContext } from "react";
export const tops = [
    {
      imageurl:
        "https://m.media-amazon.com/images/I/71oq4d1UQ3L._AC_SR255,340_.jpg",
      brand: "CeCe",
      desc: "Short sleves Round Neck Tees",
      ratings: 20864,
      price: 50,
      id: 1,
    },
    {
      imageurl:
        "https://m.media-amazon.com/images/I/81I2hM50A8L._AC_SR255,340_.jpg",
      brand: "Nic+Zoe",
      desc: "Perfect Layer 3/4 sleves",
      ratings: 777,
      price: 69.95,
      id: 2,
    },
    {
      imageurl:
        "https://m.media-amazon.com/images/I/71e5Qmj+zdL._AC_SR255,340_.jpg",
      brand: "Madewells",
      desc: "Puff Sleeves Mixed Media Knit Top",
      ratings: 729,
      price: 98.11,
      id: 3,
    },
    {
      imageurl:
        "https://m.media-amazon.com/images/I/81EFawko13L._AC_SR255,340_.jpg",
      brand: "Henes",
      desc: "Lily Top",
      ratings: 323,
      price: 34.34,
      id: 4,
    },
    {
      imageurl:
        "https://m.media-amazon.com/images/I/61nDXvlWZiL._AC_SR255,340_.jpg",
      brand: "Alternative",
      desc: "Step Herm PopoVern In Layers",
      ratings: 5678,
      price: 45.34,
      id: 5,
    },
    {
      imageurl:
        "https://m.media-amazon.com/images/I/81lM9tJEsML._AC_SR255,340_.jpg",
      brand: "Armour",
      desc: "Short-Sleves Relaxed Tee",
      ratings: 809,
      price: 19.23,
      id: 6,
    },
    {
      imageurl:
        "https://m.media-amazon.com/images/I/81vvUmdmonL._AC_SR255,340_.jpg",
      brand: "Madewell",
      desc: "UA-Tech VNeck Sleves",
      ratings: 620,
      price: 150.23,
      id: 7,
    },
    {
      imageurl:
        "https://m.media-amazon.com/images/I/710ehjlRSeL._AC_SR255,340_.jpg",
      brand: "Free People",
      desc: "Plus Size American Badge Of Sports",
      ratings: 144,
      price: 76.23,
      id: 8,
    },
    {
      imageurl:
        "https://m.media-amazon.com/images/I/81wNdYGAB-L._AC_SR255,340_.jpg",
      brand: "AberCrombia &Fitch",
      desc: "Fether Weight Specialy For Women",
      ratings: 729,
      price: 109.1,
      id: 9,
    },
    {
      imageurl:
        "https://m.media-amazon.com/images/I/71oecDUjA7L._AC_SR255,340_.jpg",
      brand: "Salty Crew@",
      desc: "BoyFriend Tee",
      ratings: 432,
      price: 76.23,
      id: 10,
    },
    {
      imageurl:
        "https://m.media-amazon.com/images/I/91dWJ9FRq6L._AC_SR255,340_.jpg",
      brand: "Marvel",
      desc: "Ideal Tee With Perfect Layer",
      ratings: 234,
      price: 229.19,
      id: 11,
    },
    {
      imageurl:
        "https://m.media-amazon.com/images/I/81q1jEcBRZS._AC_SR255,340_.jpg",
      brand: "Armour",
      desc: "Model Tee Blend Racer Tee",
      ratings: 901,
      price: 89.09,
      id: 12,
    },
    {
      imageurl:
        "https://m.media-amazon.com/images/I/715Rj4146vL._AC_SR255,340_.jpg",
      brand: "Free People",
      desc: "Short Sleeves Two Button Classic Fitness",
      ratings: 81,
      price: 29.29,
      id: 13,
    },
    {
      imageurl:
        "https://m.media-amazon.com/images/I/81r+IJ6FyBL._AC_SR255,340_.jpg",
      brand: "Life is Good",
      desc: "Light Weight Slub Jersy Short Sleeves",
      ratings: 64,
      price: 120.22,
      id: 14,
    },
    {
      imageurl:
        "https://m.media-amazon.com/images/I/91crWsr7gJL._AC_SR255,340_.jpg",
      brand: "Carve Design",
      desc: "Wisper Cotton V-Neck Tee",
      ratings: 976,
      price: 200.05,
      id: 15,
    },
    {
      imageurl:
        "https://m.media-amazon.com/images/I/81EFCTkSdxL._AC_SR255,340_.jpg",
      brand: "Life is Good",
      desc: "Women 3/4 Active Tee With Design",
      ratings: 2000,
      price: 102.38,
      id: 16,
    },
  ];


  export const WomenPage = () => {
    // const [product,setProduct] = useState(tops)
   
    const {handleAdd} = useContext(AppContext)
  

  


   
    return (
      <>
      <Navbar />
      <Box bg='lavender' h='40px' w='100%' m='auto' p='5px'>
      <Text fontSize='lg'>Be the first to shop the newest home styles—now on Zappos! Shop Home Now</Text>
      </Box>

      <Box mt='20px' mb='40px'>
      <Heading as='h2' size='xl'>Women's Shirts & Tops</Heading>
      
      </Box>
      <div className={styles.gridDiv}>
      { 
        tops.map((data) => {
            return  (
               <div className={styles.flexDiv}>
               <div>
                <img src={data.imageurl}  />
               </div>
                <p className={styles.desc}>{data.desc}</p>
                <p className={styles.brand}>{data.brand}</p>
                <p className={styles.price}>${data.price}</p>
                <Button  
                colorScheme='teal' variant='solid'
                 w='150px'h='40px' m='auto' mb='10px'
                 onClick={() => handleAdd(data.id) }
                 >Add to card</Button>
            </div> 
        
            )
 
        })
    
      }
      </div>
      <Footer />
      </>

    );
  };
  